import React from 'react';

import { Grid } from '@mui/material';
import { Layout } from 'features/common/components/Layout';
import SalesOrderFromExternalRedirect from './Netsuite/components/SalesOrderFromExternalRedirect';

export const SalesOrderFromExternalRedirectPage = (): JSX.Element => {
	return (
		<Layout>
			<Grid container justifyContent={'center'}>
				<Grid item xs={12} paddingY={5}>
					<SalesOrderFromExternalRedirect />
				</Grid>
			</Grid>
		</Layout>
	);
};
